import { escapeRegExp } from 'lodash'

/** Подсвечивает вхождения `searchQuery` в `text` (HTML). Пустой query — без изменений. */
export default function highlightSearchText(text: string, searchQuery: string): string {
  const query = searchQuery.trim()

  if (!query) {
    return text
  }

  return text.replace(
    new RegExp(`(${escapeRegExp(query)})`, 'ig'),
    '<span class="text-subtitle-1 primary--text">$1</span>',
  )
}
